/**
 * This function is rounding a value based on the step value
 * Ex: If the step is 0.5 and the value is 1.6, the output will be 1.5
 */
export const roundByStep = (value: number, step: number) => {
  const inverse = 1.0 / step;
  return Math.round(value * inverse) / inverse;
};
